import React from 'react';
import { Spinner } from '@gsa/afp-component-library';
import { PropTypes } from 'prop-types';
import { useQuery } from '@apollo/client';
import { GET_BID_LINES_BY_MAKE_MODEL } from '../queries.gql';
import { emDashUnicode } from '../../../utilities/constants';
import MakeModelComments from '../components/make-model-comments';

const MakeModelApprovalDetailRow = ({
  comments,
  makeCode,
  modelCode,
  chassisMakeCode,
  chassisModelCode,
}) => {
  const { data, loading } = useQuery(GET_BID_LINES_BY_MAKE_MODEL, {
    variables: {
      makeModelSearchInput: {
        makeCode,
        modelCode,
        chassisMakeCode,
        chassisModelCode,
      },
    },
  });
  const rows = data?.getBidLinesByMakeAndModel || [];

  if (loading) return <Spinner data-testid="spinner" size="small" />;

  return (
    <div className="grid-container">
      <div className=" border-bottom border-base-lighter padding-bottom-1">
        <div className="grid-row margin-bottom-2">
          <div className="grid-col flex-2 text-bold">Solicitation#</div>
          <div className="grid-col flex-4">
            <div>
              {rows && rows.length > 0 ? (
                <>
                  {
                    rows[0].solicitationLine?.solicitationProgram?.solicitation
                      ?.solicitationNumber
                  }
                </>
              ) : (
                <span>{emDashUnicode}</span>
              )}
            </div>
          </div>
          <div className="grid-col flex-2 text-bold">Vehicle Program</div>
          <div className="grid-col flex-4">
            <div>
              {rows && rows.length > 0 ? (
                <>{rows[0].solicitationLine?.solicitationProgram?.program}</>
              ) : (
                <span>{emDashUnicode}</span>
              )}
            </div>
          </div>
        </div>
        <div className="grid-row">
          <div className="grid-col flex-2 text-bold">Comments</div>
          <div className="grid-col flex-10">
            <MakeModelComments comments={comments} />
          </div>
        </div>
      </div>
    </div>
  );
};

MakeModelApprovalDetailRow.propTypes = {
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      comment: PropTypes.string,
      createdAt: PropTypes.string,
      createdBy: PropTypes.string,
      createdByUser: PropTypes.shape({
        email: PropTypes.string,
        fullName: PropTypes.string,
      }),
    }),
  ).isRequired,
  makeCode: PropTypes.number,
  modelCode: PropTypes.string,
  chassisMakeCode: PropTypes.number,
  chassisModelCode: PropTypes.string,
};

export default MakeModelApprovalDetailRow;
